import {
    takeEvery,
    call,
    all,
    put,
    fork,
} from 'redux-saga/effects';

import { types, actions } from './reducer';
import SeasonService from '@iso/services/SettingsService/ProductService/SeasonService';
import { extractError } from '@iso/lib/helpers/api';

function* submitSeason({ id, data }) {
    try {
        let response;
        if(id) {
            response = yield call(SeasonService.editSeason, id, data);
        } else {
            response = yield call(SeasonService.addSeason, data);
        }
        yield put(actions.submitSeasonSucceeded(response.data));
    } catch (error) {
        yield put(actions.submitSeasonFailed(extractError(error)));
    }
}

function* watchSubmitSeason() {
    yield takeEvery(
        types.REQUEST_SUBMIT_SEASON,
        submitSeason,
    );
}

function* createSaga() {
    yield all([
        fork(watchSubmitSeason),
    ]);
}

export default createSaga;